export function getCookie(name: string) {
  const m = document.cookie.match(new RegExp('(^|; )' + RegExp.escape(name) + '=([^;]*)'));
  return m ? decodeURIComponent(m[2]) : null;
}

export const getCSRFTokenCookie = () => {
  const environment = window.environment;
  let prefix = '';
  if (environment === 'production') {
    prefix = '__Secure-prod_';
  }
  if (environment === 'staging') {
    prefix = '__Secure-stg_';
  }
  return getCookie(`${prefix}csrftoken`);
};
